export const SEARCH_QUERY_MAX_LENGTH = 30;

export function clampSearchQuery(value) {
    if (value == null) {
        return '';
    }
    return String(value).slice(0, SEARCH_QUERY_MAX_LENGTH);
}
